export var IS_DEVELOPMENT_MODE_TEST = process.env.NODE_ENV === 'test';